/* General Functions for this App */

// Function to remark the mandatory fields
const addInvalid = (node, boolean) => {
    if(node){
        if(boolean){
            if(!node.classList.contains('invalid')){
                node.classList.add('invalid');
            }
        }else{
            if(node.classList.contains('invalid')){
                node.classList.remove('invalid');
            }
        }
    }
}

//  Evet to toogle the Left Menu
const menuBar = () => {
    let btnMenu = document.querySelectorAll('.btnMenu');
    btnMenu.forEach(ele => {
        ele.classList.toggle('opened');
    });
    let leftMenu = document.querySelector('#leftMenu');
    leftMenu.classList.toggle('opened');
}

// Clean numeric values
const toNumeric = (value) => {

    if(value === null) return null;

    if (typeof value !== 'string') {
        value = String(value ?? '');
    }

    let number;

    if(value === ''){
        number = 0;
    }else{
         // Remove any character that is not a digit or dot
        number = value.replace(/[^0-9.]/g, '');
    }

    return parseFloat(number);
}

// Function to calculate the Premium value 
const calculatePremium =  (formData) => {
    // Get all the parameters
    const {
        fob,
        flete,
        tax,
        extraExpensesCheck,
        operationalExpensesCheck,
        rate,
        minPremium,
        setSubtotal,
        setExtraExpenses,
        setOperationalExpenses,
        setTotalInsured,
    } = formData;

	// Vars
    let invalid = false;
	let result;

    // Validar que el valor Fob y la Tarifa no sean nulos
     if(fob === '' || rate === '') { 

        let body = document.querySelector('body');
        let fobField = document.querySelector('#fob_value');
        let rateField = document.querySelector('#rate_value');
        
        invalid = true;

        // remark the mandatory fields
        addInvalid(body, invalid);
        (fob === '') ?  addInvalid(fobField, true) : addInvalid(fobField, false);
        (rate === '') ?  addInvalid(rateField, true) : addInvalid(rateField, false);
    }

     //Si no es Invalido Comenzamos a calcular la Prima
    if(!invalid){

        // Let's clean all the value
        let c_fob = toNumeric(fob);
        let c_flete = toNumeric(flete);
        let c_tax = toNumeric(tax);
        let c_rate = toNumeric(rate);
        let c_minPremium = toNumeric(minPremium);
        let c_subtotal, c_totalInsured, c_extraExpenses, c_operationalExpenses;

        //Subtotal = Valor FOB + Flete + tax (Arancel)
        c_subtotal = c_fob + c_flete + c_tax;
        setSubtotal(c_subtotal);

        // Gastos Adicionales (10%) = Subtotal * 0,1
        (extraExpensesCheck) ? c_extraExpenses = c_subtotal * 0.1 : c_extraExpenses = 0;
        setExtraExpenses(c_extraExpenses);

        // Gastos Operativos (10%) = Valor FOB * 0,1
        (operationalExpensesCheck) ? c_operationalExpenses  = c_fob * 0.1 : c_operationalExpenses = 0;
        setOperationalExpenses(c_operationalExpenses);
        

        // Valor Asegurado Total = Subtotal + Gastos Adicionales (10%) + Gastos Operativos (10%)
        c_totalInsured = c_subtotal + c_extraExpenses + c_operationalExpenses;
        setTotalInsured(c_totalInsured);

        /* Prima o Costo del Certificado de Seguro = 
        Si (Valor Asegurado Total * Tasa) <= Prima Mínima de Venta Entonces la Prima o
            Costo del seguro va a ser igual a la Prima Mínima de Venta.
        Si no, va a ser igual al (Valor Asegurado Total * Tasa).
        */
        (c_totalInsured * c_rate <= c_minPremium) ? result = c_minPremium : result = c_totalInsured * c_rate;
    }

	return result;
};

// Validar números válidos
const isValidNumber = (value) => {
    return value !== null && value !== '' && !isNaN(value) && isFinite(value);
};

export {calculatePremium, menuBar, addInvalid, toNumeric, isValidNumber};